export default __webpack_public_path__ + "static/media/loadingbrain-gray.47baa176.svg";